import profile from './profile'
import keys from './keys'
import fazendas from './fazendas'
import produtores from './produtores'
import notificacoesTecnico from './notificacoesTecnico'
import planoPagamento from './planoPagamento'
import relatorios from './relatorios'

const permissions = [
  {
    role: 'admin',
    access: false,
    redirect: 'admin',
  },
  {
    role: 'supervisor',
    access: false,
    redirect: 'supervisor',
  },
  {
    role: 'gestor',
    access: false,
    redirect: 'gestor',
  },
  {
    role: 'guest',
    access: false,
    redirect: 'login',
  },
]

/* ACESSO TECNICO */
export default {
  name: 'tecnico',
  path: '/tecnico',
  redirect: '/tecnico/dashboard',
  component: () => import('@/views/Index'),
  meta: { requiresAuth: true, permissions },
  children: [
    {
      path: 'dashboard',
      component: () => import('@/views/dashboard/DashboardTecnico'),
      meta: { permissions, title: 'Início' },
    },
    fazendas.router(permissions),
    produtores.router(permissions),
    profile.router(permissions),
    keys.router(permissions),
    notificacoesTecnico.router(permissions),
    planoPagamento.router(permissions),
    relatorios.router(permissions),
  ],
}
